import { render } from "./Voluum.vue?vue&type=template&id=74f90840&scoped=true&lang=pug"
const script = {}

import "./Voluum.vue?vue&type=style&index=0&id=74f90840&lang=css&scoped=true"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f90840"]])

export default __exports__